import React from "react";
import { Card, Divider } from "antd";
import { Link } from "react-router-dom";
import { IoDocument } from "react-icons/io5";
import { FaClipboardList, FaUsers } from "react-icons/fa";
import colours from "../../constants/colours";

const QUICK_LINKS = [
  { to: "/reports", icon: <IoDocument />, label: "Generate a report" },
  { to: "/join", icon: <FaUsers />, label: "Join a cohort via code" },
  { to: "/plans", icon: <FaClipboardList />, label: "See all plans"}
];

const QuickLink = ({ to, icon, label }) => (
  <Link to={to} className="group flex flex-row gap-3 items-center">
    <div className="text-sm text-primary group-hover:text-primaryLight">{icon}</div>
    <p className="text-primary text-xs font-medium group-hover:underline group-hover:text-primaryLight">{label}</p>
  </Link>
);

const QuickLinksCard = () => {
  return (
    <Card title="Quick links" className="flex-1 bg-white rounded-lg shadow-md">
      <div className="flex flex-col">
        {QUICK_LINKS.map((link, i) => (
          <React.Fragment key={link.to}>
            <QuickLink {...link} />
            {i < QUICK_LINKS.length - 1 && (
              <Divider style={{ borderColor: colours.background, margin: "10px" }} />
            )}
          </React.Fragment>
        ))}
      </div>
    </Card>
  );
};

export default QuickLinksCard;